import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { aboutImages, aboutHighlights, business } from "@/config/site";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-ivory py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
        {/* Left: images (asymmetric, clipped/arched) */}
        <Reveal className="relative">
          <div className="relative">
            <span className="font-display text-[7rem] sm:text-[9rem] leading-none text-champagne/20 absolute -top-16 -left-2 select-none">
              01
            </span>
            {aboutImages.large ? (
              <img
                src={aboutImages.large}
                alt="Aarambh.KD celebration"
                loading="lazy"
                className="arch-top w-full h-[420px] sm:h-[540px] object-cover shadow-xl"
              />
            ) : (
              // Elegant gradient placeholder (no stock photos). Set aboutImages.large in config.
              <div className="arch-top relative w-full h-[420px] sm:h-[540px] overflow-hidden shadow-xl bg-gradient-to-br from-maroon via-[#7a2a2a] to-charcoal flex items-center justify-center">
                <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_50%_30%,#C9A227,transparent_60%)]" />
                <span className="font-display italic text-4xl text-champagne/80">Aarambh.KD</span>
              </div>
            )}
            {aboutImages.small ? (
              <img
                src={aboutImages.small}
                alt="Aarambh.KD detail"
                loading="lazy"
                className="absolute -bottom-10 -right-4 sm:right-[-2rem] w-40 sm:w-56 h-52 sm:h-72 object-cover rounded-2xl border-4 border-ivory shadow-2xl hidden sm:block"
              />
            ) : (
              <div className="absolute -bottom-10 -right-4 sm:right-[-2rem] w-40 sm:w-56 h-52 sm:h-72 rounded-2xl border-4 border-ivory shadow-2xl hidden sm:flex items-center justify-center overflow-hidden bg-gradient-to-br from-champagne/40 to-maroon/50">
                <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_40%_40%,#C9A227,transparent_65%)]" />
                <span className="font-display italic text-2xl text-white/90">KD</span>
              </div>
            )}
          </div>
        </Reveal>

        {/* Right: manifesto text */}
        <div className="flex flex-col justify-center">
          <Reveal><Eyebrow>About {business.name}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-charcoal">
              A trusted legacy of <span className="italic text-maroon">celebrations</span>,
              under one roof.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-charcoal/70 leading-relaxed">
              Aarambh.KD is the event management division powered by the trusted
              legacy of <strong className="text-maroon">{business.poweredBy}</strong>.
              With years of experience in event infrastructure, décor and
              large-scale celebrations, we provide complete event solutions under
              one roof.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-4 text-charcoal/70 leading-relaxed">
              Our goal is to make every celebration stress-free, elegant and
              memorable — handling every detail with professionalism and creativity.
            </p>
          </Reveal>

          <Reveal delay={0.4}>
            <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {aboutHighlights.map((h) => (
                <div key={h} className="flex items-center gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-champagne/15">
                    <Check className="h-3.5 w-3.5 text-champagne" strokeWidth={2.5} />
                  </span>
                  <span className="text-sm text-charcoal/80">{h}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
